// @ts-nocheck
// Collection-page behavior. Loaded only on collection templates.
// sub-category on collection page

document.addEventListener("DOMContentLoaded", function () {
    const wrappers = document.querySelectorAll(".sub-category-menu-wrapper");
    if (!wrappers.length) return;
  
    wrappers.forEach((wrapper) => {
      const scroller = wrapper.querySelector(".sub-category-menu");
      const btnLeft = wrapper.querySelector(".sub-cat-arrow--left");
      const btnRight = wrapper.querySelector(".sub-cat-arrow--right");
      if (!scroller || !btnLeft || !btnRight) return;
  
  
      const getScrollStep = () => Math.floor(scroller.clientWidth * 0.8);
  
      const updateArrows = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        const atStart = scroller.scrollLeft <= 2;
        const atEnd = scroller.scrollLeft >= maxScroll - 2;
  
        btnLeft.setAttribute("aria-hidden", atStart);
        btnRight.setAttribute("aria-hidden", atEnd);
        btnLeft.disabled = atStart;
        btnRight.disabled = atEnd;
  
  
        if (scroller.scrollWidth <= scroller.clientWidth + 1) {
          btnLeft.setAttribute("aria-hidden", "true");
          btnRight.setAttribute("aria-hidden", "true");
          btnLeft.disabled = true;
          btnRight.disabled = true;
        }
      };
  
      const scrollByStep = (dir) => {
        scroller.scrollBy({ left: getScrollStep() * dir, behavior: "smooth" });
  
        clearTimeout(scroller._scrollTimeout);
        scroller._scrollTimeout = setTimeout(updateArrows, 250);
      };
  
  
      btnLeft.addEventListener("click", () => scrollByStep(-1));
      btnRight.addEventListener("click", () => scrollByStep(1));
  
  
      let ticking = false;
      scroller.addEventListener("scroll", () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            updateArrows();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
  
  
      window.addEventListener("resize", () => {
        clearTimeout(scroller._resizeTimeout);
        scroller._resizeTimeout = setTimeout(updateArrows, 150);
      });
  
  
      scroller.addEventListener("focusin", (e) => {
        const el = e.target;
        if (!el || !scroller.contains(el)) return;
        const left = el.offsetLeft;
        const right = left + el.offsetWidth;
        if (left < scroller.scrollLeft) {
          scroller.scrollTo({ left: left - 12, behavior: "smooth" });
        } else if (right > scroller.scrollLeft + scroller.clientWidth) {
          scroller.scrollTo({ left: right - scroller.clientWidth + 12, behavior: "smooth" });
        }
      });
  
      scroller.scrollLeft = 0;
      setTimeout(updateArrows, 80);
    });
  });
  